import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const setSections = 'section/setSections';
const setCurrentSection = 'section/setCurrentSection';
const setNextSection = 'section/setNextSection';
const updateSection = 'section/updateSection';
const sectionSwitchComplete = 'section/sectionSwitchComplete';
const setHiddenSection = 'section/setHiddenSection';
const closeHiddenSection = 'section/closeHiddenSection';
const notifyExportHiddenSection = 'section/notifyExportHiddenSection';
const setLinkLabels = 'section/setLinkLabels';
const notifyLinkNavigation = 'section/notifyLinkNavigation';
const addNewSection = 'section/addNewSection';
const editTabLabel = 'section/editTabLabel';
const setTabsEditable = 'section/setTabsEditable';
const setEmptyViewEditable = 'section/setEmptyViewEditable';
const notifyTabMenuOpen = 'section/notifyTabMenuOpen';
const notifyReorderTabs = 'section/notifyReorderTabs';
const selectTabMenuItem = 'section/selectTabMenuItem';
const fadeTransition = 'section/setFadeTransition';
const notifyPressCreateAutoChart = 'section/notifyPressCreateAutoChart';
const notifyPressSelectTemplate = 'section/notifyPressSelectTemplate';
const notifyPressExploreSuggestions = 'section/notifyPressExploreSuggestions';
const notifyDrop = 'section/notifyDrop';
const setTabDropTypes = 'section/setTabDropTypes';
const notifyTabClose = 'section/notifyTabClose';
const setShowCreateAutoChart = 'section/setShowCreateAutoChart';
export const SectionState = {
    actions: {
        setSections: (sections) => action(setSections, sections),
        setCurrentSection: (currentSection) => action(setCurrentSection, currentSection),
        setNextSection: (sectionId) => action(setNextSection, sectionId),
        updateSection: (sectionId, sectionData) => action(updateSection, { sectionId, sectionData }),
        sectionSwitchComplete: (finalize) => action(sectionSwitchComplete, finalize),
        setHiddenSection: (hiddenSection) => action(setHiddenSection, hiddenSection),
        closeHiddenSection: () => action(closeHiddenSection),
        notifyExportHiddenSection: (event) => action(notifyExportHiddenSection, event),
        setLinkLabels: (labels) => action(setLinkLabels, labels),
        notifyLinkNavigation: (linkStackIndex) => action(notifyLinkNavigation, linkStackIndex),
        addNewSection: () => action(addNewSection),
        setTabsEditable: (value) => action(setTabsEditable, value),
        editTabLabel: (event) => action(editTabLabel, event),
        setEmptyViewEditable: (value) => action(setEmptyViewEditable, value),
        notifyTabMenuOpen: (event) => action(notifyTabMenuOpen, event),
        notifyReorderTabs: (prevIndex, newIndex) => action(notifyReorderTabs, { prevIndex, newIndex }),
        selectTabMenuItem: (event) => action(selectTabMenuItem, event),
        fadeTransition: (value) => action(fadeTransition, value),
        notifyPressCreateAutoChart: (sectionId) => action(notifyPressCreateAutoChart, sectionId),
        notifyPressSelectTemplate: (sectionId) => action(notifyPressSelectTemplate, sectionId),
        notifyPressExploreSuggestions: (sectionId) => action(notifyPressExploreSuggestions, sectionId),
        notifyDrop: (value) => action(notifyDrop, value),
        setTabDropTypes: (value) => action(setTabDropTypes, value),
        notifyTabClose: (itemIndex) => action(notifyTabClose, itemIndex),
        setShowCreateAutoChart: (value) => action(setShowCreateAutoChart, value),
    },
    actionTypes: {
        setSections,
        setCurrentSection,
        setNextSection,
        sectionSwitchComplete,
        updateSection,
        setHiddenSection,
        closeHiddenSection,
        notifyExportHiddenSection,
        setLinkLabels,
        notifyLinkNavigation,
        addNewSection,
        setTabsEditable,
        editTabLabel,
        setEmptyViewEditable,
        notifyTabMenuOpen,
        notifyReorderTabs,
        selectTabMenuItem,
        fadeTransition,
        notifyPressCreateAutoChart,
        notifyPressSelectTemplate,
        notifyPressExploreSuggestions,
        notifyDrop,
        setTabDropTypes,
        notifyTabClose,
        setShowCreateAutoChart,
    },
    reducer: createReducer({
        byId: {},
        currentSection: undefined,
        transitioning: false,
        sectionTabOrder: [],
    }, {
        [setTabsEditable]: (state, action) => (Object.assign(Object.assign({}, state), { tabsEditable: action.payload })),
        [setEmptyViewEditable]: (state, action) => (Object.assign(Object.assign({}, state), { emptyViewEditable: action.payload })),
        [setSections]: (state, action) => {
            const byId = {};
            const sectionTabOrder = [];
            for (const section of action.payload) {
                byId[section.id] = section;
                if (!section.hidden) {
                    sectionTabOrder.push(section.id);
                }
            }
            return Object.assign(Object.assign({}, state), { byId,
                sectionTabOrder });
        },
        [setCurrentSection]: (state, action) => {
            return Object.assign(Object.assign({}, state), { currentSection: action.payload, transitioning: state.currentSection !== undefined });
        },
        [setNextSection]: (state, action) => {
            return Object.assign(Object.assign({}, state), { nextSection: action.payload });
        },
        [updateSection]: (state, action) => {
            const id = action.payload.sectionId;
            return Object.assign(Object.assign({}, state), { byId: Object.assign(Object.assign({}, state.byId), { [id]: Object.assign(Object.assign({}, state.byId[id]), action.payload.sectionData) }) });
        },
        [setHiddenSection]: (state, action) => {
            return Object.assign(Object.assign({}, state), { hiddenSection: action.payload || undefined });
        },
        [sectionSwitchComplete]: (state, action) => {
            if (!state.transitioning) {
                return state;
            }
            const newState = Object.assign(Object.assign({}, state), { transitioning: false });
            if (action.payload /* finalize */) {
                newState.currentSection =
                    state.nextSection === undefined ? state.currentSection : undefined;
            }
            return newState;
        },
        [closeHiddenSection]: (state, _action) => {
            return Object.assign(Object.assign({}, state), { hiddenSection: undefined });
        },
        [setLinkLabels]: (state, action) => {
            return Object.assign(Object.assign({}, state), { linkLabels: action.payload });
        },
        /**
         * @deprecated not supported
         */
        [fadeTransition]: (_state, _action) => {
            throw new Error('fadeTransition is not supported');
            // return { ...state, fadeTransition: action.payload };
        },
        [setTabDropTypes]: (state, action) => {
            return Object.assign(Object.assign({}, state), { tabDropTypes: action.payload });
        },
        [setShowCreateAutoChart]: (state, action) => (Object.assign(Object.assign({}, state), { showCreateAutoChart: action.payload })),
    }),
};
